var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed, action } from 'mobx';
import { generateTicketNumber, randomString, round } from 'helpers/Utils';
import { TypePrice } from '../PassengerCategories/Model';
export class TempSaleTicketLine {
    constructor(sale) {
        this.numeroQR = [];
        this.setQuantity = (quantity) => {
            this.quantity = quantity;
        };
        this.setDiscount = (discount) => {
            this.descuento = discount;
        };
        this.setStretchPrice = (stretchPrice) => {
            this.stretchPrice = stretchPrice;
        };
        this.setTax = (tax) => {
            this.tax = tax;
        };
        this.setSale = (sale) => {
            this.sale = sale;
            this.stretchPrice = sale.stretchPrice;
        };
        this.toJSON = () => {
            const collaboratorSaleFields = {};
            if (this.stretchPrice.priceNet) {
                collaboratorSaleFields['totalNet'] = round(this.totalNet, 2);
            }
            const toSend = Object.assign(Object.assign({}, collaboratorSaleFields), { price: round(this.stretchPrice.price, 2), passengerCategory_id: this.stretchPrice.passengerCategory.id, passengerCategoryName: this.stretchPrice.passengerCategory.name, quantity: this.quantity, taxBase: round(this.base, 2), taxAmount: round(this.taxAmount, 2), tax_id: this.tax.id, taxName: this.tax.name, taxValue: this.tax.value, discount: this.descuento, total: round(this.base + this.taxAmount, 2), numeroQR: this.numeroQR });
            return toSend;
        };
        this.sale = sale;
        this.stretchPrice = sale.stretchPrice;
        // ya le pongo una unidad
        this.quantity = sale.quantity > 0 ? sale.quantity : 1;
        this.descuento = 0;
        this.stretchPrice = sale.stretchPrice;
        this.setTax(sale.stretchPrice.tax);
        const numeroNew = generateTicketNumber(randomString(6), 'stretch');
        this.numeroQR.push(numeroNew);
    }
    get base() {
        if (this.stretchPrice.passengerCategory.typePrice === TypePrice.byGroup)
            return this.stretchPrice.price;
        // el resto
        return this.stretchPrice.price * this.quantity;
    }
    get baseNet() {
        if (this.stretchPrice.passengerCategory.typePrice === TypePrice.byGroup)
            return this.stretchPrice.priceNet;
        // el resto
        return this.stretchPrice.priceNet * this.quantity;
    }
    get taxes() {
        return this.tax.value;
    }
    get taxAmount() {
        // console.log('TemSaleTicketLine - this.tax: ', this.tax)
        if (this.stretchPrice.passengerCategory.typePrice === TypePrice.byGroup)
            return this.tax.value * this.stretchPrice.price;
        // el resto
        return this.tax.value * this.stretchPrice.price * this.quantity;
    }
    get taxAmountNet() {
        // console.log('TemSaleTicketLine - this.tax: ', this.tax)
        if (this.stretchPrice.passengerCategory.typePrice === TypePrice.byGroup)
            return this.tax.value * this.stretchPrice.priceNet;
        // el resto
        return this.tax.value * this.stretchPrice.priceNet * this.quantity;
    }
    get total() {
        return this.base + this.taxAmount;
    }
    get totalNet() {
        return this.baseNet + this.taxAmountNet;
    }
    get discount() {
        return this.descuento;
    }
}
__decorate([
    observable
], TempSaleTicketLine.prototype, "sale", void 0);
__decorate([
    observable
], TempSaleTicketLine.prototype, "quantity", void 0);
__decorate([
    observable
], TempSaleTicketLine.prototype, "descuento", void 0);
__decorate([
    observable
], TempSaleTicketLine.prototype, "stretchPrice", void 0);
__decorate([
    observable
], TempSaleTicketLine.prototype, "tax", void 0);
__decorate([
    computed
], TempSaleTicketLine.prototype, "base", null);
__decorate([
    computed
], TempSaleTicketLine.prototype, "baseNet", null);
__decorate([
    computed
], TempSaleTicketLine.prototype, "taxes", null);
__decorate([
    computed
], TempSaleTicketLine.prototype, "taxAmount", null);
__decorate([
    computed
], TempSaleTicketLine.prototype, "taxAmountNet", null);
__decorate([
    computed
], TempSaleTicketLine.prototype, "total", null);
__decorate([
    computed
], TempSaleTicketLine.prototype, "totalNet", null);
__decorate([
    action
], TempSaleTicketLine.prototype, "setQuantity", void 0);
__decorate([
    action
], TempSaleTicketLine.prototype, "setDiscount", void 0);
__decorate([
    action
], TempSaleTicketLine.prototype, "setStretchPrice", void 0);
__decorate([
    action
], TempSaleTicketLine.prototype, "setTax", void 0);
__decorate([
    action
], TempSaleTicketLine.prototype, "setSale", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/TempSale/TempSaleTicketLine.ts
// module id = 358
// module chunks = 0